<template>
    <div>
        <Head>
            <title>Preferences - Innovative Scholars</title>
        </Head>
        <PageTitle 
            title="Preferences" 
            subtitle="Update my preferences"
        />
        <div class="container">
            <div>
                <div class="my-6">
                    <p class="text-lg font-medium flex items-center"> 
                        <BellIcon class="h-6 w-6 mr-2" />
                        Notifications 
                    </p>
                </div>
                <SwitchGroup>
                    <div class="flex items-center">
                        <Switch
                            v-model="form.notifications.classes.created"
                            :class='form.notifications.classes.created ? "bg-primary-500" : "bg-gray-200"'
                            class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 mr-4"
                        >
                            <span
                            :class='form.notifications.classes.created ? "translate-x-6" : "translate-x-1"'
                            class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
                            />
                        </Switch>
                        <SwitchLabel>Email me when a new class has been created</SwitchLabel>
                    </div>
                </SwitchGroup>
                <div class="my-6">
                    <hr>
                </div>
                <div class="flex items-center justify-end my-6">
                    <TransitionRoot
                        :show="changesSaved"
                        enter="transition-opacity duration-50"
                        enter-from="opacity-0"
                        enter-to="opacity-100"
                        leave="transition-opacity duration-175"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                    >
                        <p class="text-base font-medium text-primary-500 mr-4"> Changes saved! </p>
                    </TransitionRoot>
                    
                    <button type="button" class="btn btn-primary" :class="loading ? 'opacity-75' : 'opacity-100'" :disabled="loading" @click="save">
                        {{ loading ? 'Saving changes...' : 'Save Changes' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head } from '@inertiajs/inertia-vue3'
import PageTitle from '@/Shared/PageTitle'
import { Switch, SwitchGroup, SwitchLabel, TransitionRoot } from '@headlessui/vue'
import { BellIcon } from '@heroicons/vue/outline'

const props = defineProps({
    preferences: {
        type: Object,
        required: true
    },
    saveUrl: {
        type: String,
        required: true
    }
})

const form = reactive({
    ...props.preferences
})

const changesSaved = ref(false)

const loading = ref(false)

function save() {
    loading.value = true

    Inertia.post(props.saveUrl, form, {
        onSuccess: () => {
            changesSaved.value = true

             setTimeout(() => {
                changesSaved.value = false
            }, 1000)
        },
        onFinish: () => loading.value = false
    })
}
</script>
